module.exports = __webpack_public_path__ + "img/269-2.1f2516df.png";